import _ from "lodash";
import { flow } from "mobx";
import { observer } from "mobx-react";
import { Button } from "primereact/button";
import React, { useContext } from "react";
import { useQueryClient } from "react-query";
import { invalidateQueries } from "../../WSUtils/useLatestQuery";
import { candidateAPI } from "../../api/candidate";
import { AttachCandidateToCaseResponse } from "../../api/candidate/attachCandidateToCase";
import { UserInfoContext } from "../../WSUtils/UserInfoContext";
import { concatClassnames } from "../../WSUtils/util";
import { CVEditContext } from "./CVEditContext";
import { useLocStore } from "../../wsLocalization";
import { storageArea } from "../../WSUtils/storageArea";
import { LocContext } from "../../wsLocalization/LocContext";

export const CVEditApplyForPositionButton = observer(() => {
  const L = useLocStore(LocContext.CV);
  const cvEditContext = useContext(CVEditContext);
  const userInfo = useContext(UserInfoContext);
  const queryClient = useQueryClient();

  if (!cvEditContext.showApplyForPositionButton) return null;

  const onClick = flow(function* (evt) {
    evt.preventDefault();

    const applyingForJob = cvEditContext.applyingForJob;

    const result: AttachCandidateToCaseResponse =
      yield candidateAPI.attachCandidateToCase({
        idRelated: applyingForJob.irel,
        typeRelated: applyingForJob.trel,
        publicApplicantListIsOkay: false,
        triggerSystemEvent: true,
        userInfo,
        showSentryDialogOnError: true,
      });

    if (result?.ok) {
      // candidateGetAppliedPositions is cached on backend
      // to work around it remember in session storage that
      // we applied to this position

      const key = `candidateGetAppliedPositions_${userInfo.idConcern}_${userInfo.idCandidate}`;

      const _tempApplied = storageArea.getItem(key) || "";

      const tempApplied = _tempApplied.split(",").filter((s) => !!s);
      tempApplied.push(`${applyingForJob.trel}:${applyingForJob.irel}`);

      storageArea.setItem(key, _.uniq(tempApplied).join(","));
    }

    invalidateQueries(queryClient, [
      "candidateGetAppliedPositions",
      userInfo.idCandidate,
    ]);

    return false;
  });

  return (
    <Button
      className={concatClassnames(["cve-apply-for-position-button"])}
      label={L.id("3fdc6e139c13").loc("Send søknad")}
      icon="pi pi-send"
      onClick={onClick}
    />
  );
});
